export default __webpack_public_path__ + "static/media/cabourg10.76eb9d5d.jpg";